var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymbolWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "22px",
    viewBox: "0 0 16 22",
    enableBackground: "new 0 0 16 22",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.557,
    width: 15,
    height: 22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.311,4.637L8.068,0.019l0-0.019L8.064,0.009L8.062,0v0.019L6.818,4.637L7.71,4.639l0.354-1.393 l0.355,1.393L9.311,4.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12.424,17.78h-0.971H8.28H8.135H7.977H7.832H4.659H3.687l0,0.003l-3.13,3.15L0.654,22l2.691-2.738h0.969 h3.518h0.146h0.158H8.28h3.518h0.971L15.459,22l0.098-1.066L12.424,17.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.738,18.842l0.098-1.067l-3.148-3.158H9.391H8.583H8.438H7.673H7.528H6.72H4.443h-0.02l-3.14,3.158 l0.099,1.067l2.696-2.744h2.297h1.153h0.145h0.765h0.145h1.152h2.297L14.738,18.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.002,15.666L14.1,14.6l-3.148-3.158H9.391H8.583H8.438H7.673H7.528H6.72H5.202h-0.02L2.043,14.6 l0.097,1.066l2.697-2.743h1.539h1.153h0.145h0.765h0.146h1.151h1.563L14.002,15.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M13.27,12.51l0.099-1.066L10.22,8.285H9.391H8.583H8.438H7.673H7.527H6.72H5.922h-0.02l-3.14,3.158 L2.86,12.51l2.697-2.743h0.818h1.152h0.146h0.766h0.145h1.152h0.829L13.27,12.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12.52,9.347l0.098-1.067L9.47,5.122H9.391H8.583H8.438H7.672H7.529H6.72H6.65h-0.02l-3.14,3.158 l0.098,1.067l2.697-2.744h0.089h1.153h0.144h0.766h0.145h1.152h0.079L12.52,9.347z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolWhite);
export default __webpack_public_path__ + "static/media/symbolWhite.4cad89f6610700fb859eeca1399dc298.svg";
export { ForwardRef as ReactComponent };